export const HOME = '/'
export const DASHBOARD = '/dashboard'
export const CONTENT_TYPE = '/:contentType'
export const CONTENT_ID = '/:contentType/:documentId'
export const FULL_SCHEDULE = '/full-schedule'
